import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Partner } from '../../models/partner';
import { PasswordParams } from '../../models/password-params';
import { PartnerStateService } from '../../services/partner-state.service';
import { LoginStateService } from '../../../login/services/login-state.service';
import { PartnerStateEnum } from '../../services/partner-state.enum';
import { NotificationService } from '../../../general/services/notification.service';
import { NotificationType } from '../../../general/models/notification-type';

@Component({
  selector: 'app-partner-edit',
  templateUrl: './partner-edit.component.html',
  styleUrls: ['./partner-edit.component.css']
})
export class PartnerEditComponent implements OnInit, OnDestroy {

  @ViewChild('partnerComponent', {static: true}) partnerComponent;
  partnerOriginal = new Partner();
  partner = new Partner();
  password = new PasswordParams();
  isEditDataValid = false;
  error = '';
  private _isDirty = false;

  constructor(
    private partnerStateService: PartnerStateService,
    private loginStateService: LoginStateService,
    private notificationService: NotificationService,
  ) {
  }

  ngOnInit() {
    const partner = this.partnerStateService.loggedInPartner;
    if (partner) {
      this.partnerOriginal = partner.clone;
      this.partner = partner.clone;
    }
  }

  ngOnDestroy(): void {
    this.notificationService.hide(PartnerEditComponent.name);
  }

  editDataValid() {
    this.isEditDataValid = true;
  }

  editDataInvalid() {
    this.isEditDataValid = false;
  }

  editDataDirty() {
    this.isDirty = true;
  }

  editDataNotDirty() {
    this.isDirty = false;
  }

  set isDirty(value: boolean) {
    if (this._isDirty === value) {
      return;
    }

    this._isDirty = value;
  }

  get isDirty(): boolean {
    return this._isDirty;
  }

  get isSaveEnabled(): boolean {
    return this.isEditDataValid && this.isDirty;
  }

  onAbort() {
    this.partner = this.partnerOriginal.clone;
  }

  onSave() {
    this.partnerStateService.updatePartner(this.partner).subscribe(
      done => {

        const invalidPassword = `Invalid password or password confirmation`;

        if (
          this.password.oldPassword.length
          &&
          this.password.password.length
          &&
          this.password.repeatPassword.length
        ) {
          if (this.password.password !== this.password.repeatPassword) {
            this.notificationService.show(PartnerEditComponent.name, invalidPassword);
          } else {
            this.loginStateService.changePassword(
              this.password.oldPassword,
              this.password.password,
            ).subscribe(
              done2 => {
                if (done2) {
                  this.notificationService.show(PartnerEditComponent.name, 'Data was updated', NotificationType.Success);
                  this.partnerOriginal = this.partner.clone;
                  this.partnerComponent.partnerForm.repeatEmail = ``;
                } else {
                  this.notificationService.show(PartnerEditComponent.name, invalidPassword);
                }
              },
              error => {
                this.notificationService.show(PartnerEditComponent.name, error);
              }
            );
          }
        } else {
          this.notificationService.show(PartnerEditComponent.name, 'Data was updated', NotificationType.Success);
          this.partnerOriginal = this.partner.clone;
          this.partnerComponent.partnerForm.repeatEmail = ``;
        }
      },
      error => {
        this.notificationService.show(PartnerEditComponent.name, error);
      });
  }

  onRemoveAccount() {
    this.partnerStateService.update(PartnerStateEnum.PartnerDelete);
  }
}
